angular.module('tradersyard').controller('analytic-settings-ctrl', [
    '$scope',
    'graph-analytic-factory',
    '$window',
    '$rootScope',
    function ($scope, $factory, $window, $root) {
        $scope.space = 'me';
        $scope.process = false;
        $scope.settings = [];
        $scope.form = {
            model: {},
        };

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.update = function () {
            if ($scope.process) return;

            $scope.process = false;
            $factory.settings($scope.space, { settings: $scope.form.model }).then(function ($response) {
                if ($response.data.state === 0) {
                    $window.location.href = '/analytics';
                } else if ($response.data.state === 9) {
                    $root.$broadcast('ph-modal-show', 'Invalid settings');
                }

                $scope.process = false;
            });
        };
    },
]);
